import api from '../api';

import { ParamsBank } from 'utils/typeServices';

type ParamsReponse = {
    Data: Array<ParamsBank>;
}

export const GetPaymentAvailable = async ({ token, type }: { token: string, type: number }) => {
    try {
        const { data } = await api.get<ParamsReponse>(`v1/Pagamento/ByType?paymentTypeId=${type}`, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
